import React from 'react';

import TextField from './TextField';

export default function AddressField(props) {
  const { model, label, required } = props;

  return (
    <div>
      <TextField
        model={`${model}.street`}
        inputProps={{
          placeholder: 'Rue',
        }}
        label="Adresse"
        required={required}
      />

      <TextField
        model={`${model}.city`}
        inputProps={{
          placeholder: 'Ville',
        }}
        required={required}
      />

      <TextField
        type="number"
        model={`${model}.postalCode`}
        inputProps={{
          placeholder: 'Code postal',
        }}
        required={required}
      />
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./client/form/AddressField.js
 **/